import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const painPoints = ['La duda interna que aparece cada vez que conocés a alguien.', 'La comparación constante con tipos que parecen hacer todo mal... y aun así atraen.', 'El miedo a incomodar. A ser demasiado directo. A perder lo poco que tenés.', 'Y ese pensamiento que vuelve: «No quiero llegar a los 40 así.»'];
  return <section className="py-32 bg-[#080808] relative overflow-hidden" data-id="element-140">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:32px_32px]" data-id="element-141" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-142">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white mb-20 text-center" data-id="element-143">
          Lo que nadie te dice sobre la friendzone
        </motion.h2>

        <div className="space-y-16" data-id="element-144">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className={`text-center ${index === painPoints.length - 1 ? 'text-gold font-semibold' : 'text-gray-300'}`} data-id="element-145">
              <p className="text-2xl md:text-3xl leading-relaxed font-light" data-id="element-146">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}